module.exports = __webpack_public_path__ + "img/henrikcontact.9a3fa250.png";